<template>
    <div>
        <headerNotice routerName="账户设置"></headerNotice>
        <!-- 账户设置 -->
        <div class="accountSetting" v-loading="loading">
            <h1>账户设置</h1>
            <div class="userInfo">
                <!-- <el-upload
                    :accept='accept'
                    :headers="headers"
                    class="avatar-uploader avatarBox"
                    :action="uploadAction"
                    :show-file-list="false"
                    :on-success="handleAddSuccess"
                    :before-upload="beforeUpload"
                >
                    <img
                        v-if="formData.headImgUrl"
                        :src="baseUrl+formData.headImgUrl"
                        class="avatar"
                    >
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip avatarTip">上传头像</div>
                    <div slot="tip" class="el-upload__tip uploadTip">只能上传图片，且不超过1M，建议尺寸400*400px</div>
                </el-upload> -->
                <el-form
                    :model="formData"
                    status-icon
                    ref="ruleForm"
                    label-width="100px"
                    class="formBox"
                >
                    <el-form-item class="formLabel" label="用户名:" >
                        <el-input v-model="formData.userName" disabled placeholder="请输入账号"></el-input>
                    </el-form-item>
                    <el-form-item class="formLabel" label="Email:" >
                        <el-input v-model="formData.email" placeholder="请输入邮箱号"></el-input>
                    </el-form-item>
                    <el-form-item class="formLabel" label="旧密码:">
                        <el-input
                            type="password"
                            v-model="formData.oldPassword"
                            placeholder="请输入旧密码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="formLabel" label="新密码:" >
                        <el-input
                            type="password"
                            v-model="formData.newPassword"
                            placeholder="请输入新密码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="formLabel" label="确认密码:" >
                        <el-input
                            type="password"
                            v-model="formData.confirmPassword"
                            placeholder="请确认密码"
                        ></el-input>
                    </el-form-item>
                    <el-button type="primary" class="confirmBtn" @click="submitForm('ruleForm')">确认</el-button>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
import copyRight from './../../components/common/copyRight.vue'
export default {
    data() {
        return {
            loading: false,
            baseUrl: this.$store.state.apiUrl,
            uploadAction: this.$store.state.apiUrl + '/api/services/app/Image/UploadImage',//上传的服务器api地址
            headers: {
                'Authorization': localStorage.getItem('accessToken'),
            },
            accept:".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
            formData: {
                fileName: '',
                headImgUrl: '',
                userName: '',
                email: '',
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
            },
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getUserDatas()
    },
    methods: {
        //获取用户数据
        getUserDatas() {
            let self = this;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminUser/GetUserInfo",
                success(res) {
                    self.formData.headImgUrl = res.headImgUrl;
                    self.formData.email = res.email;
                    self.formData.userName = res.userName;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //上传图片之前
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 1;
            if (file.type != 'image/jpeg' && file.type != 'image/png' ) {
                this.$message.error('上传的图片只支持JPG/PNG 的格式!');
                return false;
            }
            return true;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!');
            }
            return isLt2M;
        },
        //图片上传成功
        handleAddSuccess(response, file, fileList) {
            this.formData.headImgUrl = response.result.url;
            this.formData.fileName = response.result.fileName;
        },
        submitForm(formName) {
            let self = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    $http.POST({
                        url: self.$store.state.apiUrl + "/api/services/app/AdminUser/SetAccount",
                        data: self.formData,
                        success(res) {
                            self.$message({
                                message: '设置成功',
                                type: 'success'
                            });
                        },
                        fail(res) {
                        }
                    })
                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style lang='scss' scoped>
// 账户设置
.accountSetting {
    margin: 0 250px;
    margin-top: 20px;
    border: 1px solid #999;
    padding-bottom: 50px;
    background: #fff;
    h1 {
        background: #f3f3f3;
        padding: 10px 20px;
    }
    .userInfo {
        display: flex;
        flex-direction: column;
        align-items: center;
        .avatarBox {
            margin-top: 50px;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            .avatarTip {
                color: #1abc9c;
            }
            .uploadTip {
                padding-top: 10px;
                padding-bottom: 20px;
            }
        }
        .formBox {
            width: 500px;
            .confirmBtn {
                display: block;
                margin: 0 auto;
            }
        }
    }
}
</style>
<style lang="scss">
.accountSetting {
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
}
</style>